import request from '@/utils/request'

/**
 *货物类型-分页列表
 * @param {*} data 
 */
export function goodList(data){
    return request({
        url: '/good/list',
        method: 'post',
        data
    })
}

/**
 *货物类型-创建或修改
 * @param {*} data 
 */
export function add(data){
    return request({
        url: '/good/add',
        method: 'post',
        data
    })
}
/**
 *货物类型-移除
 * @param {*} data 
 */
export function del(data){
    return request({
        url: '/good/del',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/api/priceGoods.js